import type {$Fetch} from "nitropack";

export interface RegisterBody {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    role: string;
}
export interface AllowedUrlParams {
    redirect_to: string,
}

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface ChangePasswordRequest {
    current_password: string;
    new_password: string;
}

export interface DeleteAccountRequest {
    password: string;
}

function formatParams(params: AllowedUrlParams) {
    const queryParams = new URLSearchParams();
    queryParams.append('redirect_to', params.redirect_to);
    return queryParams.toString();
}

export const AuthRepository = (client: $Fetch) => ({
    createUser: (data: RegisterBody, params?: AllowedUrlParams) => {
        return client(`/v1/users?${params ? formatParams(params) : ''}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        })
    },
    login: (credentials: LoginCredentials) => {
        return client(`/v1/auth/sign-in`, {
            method: 'POST',
            body: credentials,
            headers: {
                'Content-Type': "application/x-www-form-urlencoded",
                'Accept': 'text/html'
            }
        });
    },
    logout: () => {
        return client(`/v1/auth/sign-out`, {
            method: 'POST'
        });
    },
    me: (params?: AllowedUrlParams) => {
        return client(`/v1/auth/me?${params ? formatParams(params) : ''}`, {
            method: 'GET',
        })
    },
    forgotPassword: (email: string) => {
      return client('/api/v1/auth/forgot-password', {
          method: 'POST',
            body: JSON.stringify({ email }),
            headers: {
                "Content-Type": "application/json",
            }
      })
    },
    changePassword: (data: ChangePasswordRequest) => {
        return client(`/v1/auth/change-password`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        })
    },
    deleteAccount: (userId: string, password: string, soft: boolean = true) => {
        return client(`/users/${userId}?soft=${soft}`, {
            method: 'DELETE',
            body: JSON.stringify({ password }),
            headers: {
                "Content-Type": "application/json",
            }
        })
    }
})